import React, { useEffect, useState } from 'react';
import api from '../api';
import Layout from '../components/Layout';

export default function Logs() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get('/logs?limite=100').then(r => setLogs(r.data)).catch(() => {});
  }, []);

  const cor = (acao) => {
    if (acao.includes('CRIAR')) return { bg:'#EAF3DE', c:'#3B6D11' };
    if (acao.includes('RESET')) return { bg:'#FAEEDA', c:'#633806' };
    if (acao.includes('DESATIVAR')) return { bg:'#FCEBEB', c:'#A32D2D' };
    return { bg:'#E6F1FB', c:'#185FA5' };
  };

  const fmt = (dt) => new Date(dt).toLocaleString('pt-BR');

  return (
    <Layout title="Auditoria de ações">
      <div style={s.table}>
        <div style={s.thead}><span>Ação</span><span>Administrador</span><span>Detalhe</span><span>IP</span><span>Data/hora</span></div>
        {logs.length === 0 && <div style={s.empty}>Nenhuma ação registrada ainda.</div>}
        {logs.map(l => {
          const c = cor(l.acao);
          return (
            <div key={l.id} style={s.row}>
              <span><span style={{...s.badge, background:c.bg, color:c.c}}>{l.acao}</span></span>
              <span style={s.admin}>{l.admin_nome}</span>
              <span style={s.detalhe}>{l.detalhe}</span>
              <span style={s.ip}>{l.ip}</span>
              <span style={s.data}>{fmt(l.criado_em)}</span>
            </div>
          );
        })}
      </div>
    </Layout>
  );
}

const s = {
  table:{background:'#fff',borderRadius:12,overflow:'hidden',boxShadow:'0 1px 4px rgba(0,0,0,0.06)'},
  thead:{display:'grid',gridTemplateColumns:'1.5fr 1.2fr 2.5fr 1fr 1.3fr',padding:'12px 20px',background:'#f8f9fa',fontSize:12,fontWeight:600,color:'#888',gap:8},
  row:{display:'grid',gridTemplateColumns:'1.5fr 1.2fr 2.5fr 1fr 1.3fr',padding:'14px 20px',borderTop:'1px solid #f0f0f0',alignItems:'center',gap:8,fontSize:12},
  badge:{padding:'2px 8px',borderRadius:20,fontSize:10,fontWeight:600},
  admin:{fontWeight:500,color:'#1a1a2e'},
  detalhe:{color:'#666'},
  ip:{color:'#999',fontFamily:'monospace'},
  data:{color:'#888'},
  empty:{padding:'32px',textAlign:'center',color:'#aaa'},
};
